import { RouterProvider } from 'react-router-dom';

// project imports
import router from './routes';
import ThemeCustomization from './themes';
import ScrollTop from './components/ScrollTop';

// импорт для работы с подтверждением пользователя
import { AuthProvider } from './auth/AuthContext';

// MUI
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// css
import './assets/style.css';

// dayjs
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/ru';

dayjs.extend(customParseFormat);
dayjs.locale('ru')


export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <LocalizationProvider dateAdapter={ AdapterDayjs } adapterLocale="ru">
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </LocalizationProvider>
      </ScrollTop>
    </ThemeCustomization>
  );
}
